export const formatAddress = (address: string) => {
  return address?.length > 8 ? `${address.slice(0, 8)}...` : address;
};
